import React, { Component } from "react";
import { AreaOnlySeries } from "./AreaOnlySeries";
import { LineSeries } from "./LineSeries";
/**
 * `AreaSeries` component is similar to a `LineSeries` but with the area between the line and base filled.
 */
export class AreaSeries extends Component {
    render() {
        const { baseAt, connectNulls, strokeStyle, strokeWidth, strokeDasharray, fillStyle, curve, canvasClip, yAccessor, } = this.props;
        return (React.createElement("g", null,
            React.createElement(AreaOnlySeries, { connectNulls: connectNulls, yAccessor: yAccessor, curve: curve, base: baseAt, fillStyle: fillStyle, canvasClip: canvasClip }),
            React.createElement(LineSeries, { connectNulls: connectNulls, yAccessor: yAccessor, strokeStyle: strokeStyle, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, curve: curve, canvasClip: canvasClip, highlightOnHover: false })));
    }
}
AreaSeries.defaultProps = {
    fillStyle: "rgba(33, 150, 243, 0.1)",
    strokeStyle: "#2196f3",
    strokeWidth: 3,
    strokeDasharray: "Solid",
};
//# sourceMappingURL=AreaSeries.js.map